import React from 'react';
import {useTranslation} from 'react-i18next';

import {Switch} from '@edna/components';
import {Icon} from '@edna/components/primitives';
import KeyboardArrowDownIcon from '@edna/icons/keyboardArrowDown.svg';

import templateLocalization, {
  EMessageAlign,
} from 'src/containers/MessageMatchers/WhatsAppForm/TemplateLocalization';
import {TMessageMatcher} from 'src/containers/MessageMatchers/definitions';
import {PhoneIcon} from 'src/icons';

import * as SS from '../style';
import {FOOTER_TIME} from '../utils';
import {Header} from './Header';
import * as S from './style';

type TProps = {
  content: TMessageMatcher['content'];
  language?: string;
  noActions?: boolean;
  children: React.ReactNode;
};

export const CallingContent = React.memo<TProps>(
  ({content = {}, language, noActions, children}) => {
    const {t, i18n} = useTranslation();
    const [isExpandedButtons, setExpandButtons] = React.useState<boolean>(false);

    const localizationIndex = templateLocalization.findIndex(
      (item) => item.code.toLowerCase() === (language?.toLowerCase() || i18n.language),
    );
    const align = templateLocalization[localizationIndex]?.align;

    const handleChangeMessagesView = React.useCallback<React.ChangeEventHandler<HTMLInputElement>>(
      (event) => {
        setExpandButtons(event.target.checked);
      },
      [],
    );

    const canExpandButtons = !noActions;

    const callingDate = React.useMemo(() => {
      const date = new Date();

      date.setDate(date.getDate() + 1);

      const month = t(`EdnaCalendar:monthsShortKeysByIndex.${date.getMonth()}`).toLowerCase();

      return `${date.getDate()} ${month}`;
    }, [t]);

    return (
      <>
        {canExpandButtons && (
          <Switch
            label={t('MessagePreview:expandButtons')}
            checked={isExpandedButtons}
            onChange={handleChangeMessagesView}
          />
        )}
        {isExpandedButtons && (
          <S.AllButtonsWrapper>
            <S.AllButtons>
              <S.Title>
                <S.CloseIcon />
                {t('MessagePreview:selectVariant')}
              </S.Title>
              <S.RadioSection>
                <S.Radio checked>{t('MessagePreview:allowCalling')}</S.Radio>
                <S.Radio>{t('MessagePreview:temporaryAllowCalling')}</S.Radio>
                <S.Radio>{t('MessagePreview:notNow')}</S.Radio>
              </S.RadioSection>
            </S.AllButtons>
          </S.AllButtonsWrapper>
        )}
        {!isExpandedButtons && (
          <SS.MessageWrapper>
            <S.Message isRtlDirection={align === EMessageAlign.RTL} hasButtons isGrey>
              <S.CallingMessageContent>
                <S.Phone>
                  <Icon as={PhoneIcon} size="20px" />
                </S.Phone>
                <S.Content>
                  {content.header && <Header header={content.header} />}
                  <S.Text>
                    {children}
                    {content.footer?.text && (
                      <>
                        <br />
                        <S.Footer>{content.footer.text}</S.Footer>
                      </>
                    )}
                    <SS.Time>
                      <span>{FOOTER_TIME}</span>
                    </SS.Time>
                  </S.Text>
                </S.Content>
              </S.CallingMessageContent>
              <S.ButtonList>
                <S.Button>
                  {t('MessagePreview:allowCallingToDate', {date: callingDate})}
                  <S.ButtonIcon as={KeyboardArrowDownIcon} />
                </S.Button>
              </S.ButtonList>
            </S.Message>
          </SS.MessageWrapper>
        )}
      </>
    );
  },
);

CallingContent.displayName = 'CallingContent';
